exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_menu_route[data-v-18d1e858]{padding:0;background:none;color:#3c3c3c!important;border-radius:0}.user_menu_route .user_menu #fullName[data-v-18d1e858]{color:#3c3c3c!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18d1e858","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/header.vue
// module id = 260
// module chunks = 0